import md5 from "md5";
import ApiService from "../ApiService";
const user = JSON.parse(localStorage.getItem("user"));

export default class UsersService {
  static getModule = async (params) => {
    const instance = await ApiService();
    return instance.get("/module");
  };

  static getData = async (params) => {
    let num, cursor, keyword, type, property, tenant;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }

    if (
      user.type === "staff" &&
      user?.operational?.id > 0 &&
      user?.operational?.level < 3
    ) {
      property = `&property_id=${user.operational.id}`;
    }

    if (user?.type === "tenant") {
      tenant = `&tenant_id=${user?.tenant?.id}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/user?${num || ""}${type || ""}${property || ""}${tenant || ""}${
        cursor || ""
      }${keyword || ""}`
    );
  };

  static storeData = async (value, objectUser) => {
    const instance = await ApiService();
    const params = {
      email: value.email,
      verified_email: true,
      default_password: false,
      password: md5(value.password),
      image_url: "https://image.com",
      name: value.name,
      username: value.email,
      birthdate: value.birthdate,
      gender: value.gender,
      token: "this is a token",
      fcm_token: "aiueo",
      fcm_token_web: "test",
      phone: value.phone,
      address: value.address,
      nationality: "indonesia",
      language: "en",
      off_duty: false,
      type: value.type,
    };
    // Role
    if (objectUser?.roles) {
      // console.log("masuk 1");
      const roleIndex = objectUser.roles.findIndex(
        (role) => role.id === value.roles
      );
      params.role =
        roleIndex > -1 ? objectUser.roles[roleIndex] : { id: value.roles };
    } else {
      // console.log("masuk 2");

      params.role = {
        id: value.roles,
      };
    }
    // Property
    if (
      (user?.operational?.level === 1 && user?.type === "staff") ||
      (user?.operational?.level === 2 &&
        user?.type === "staff" &&
        value.roles === 2) ||
      (user?.operational?.level === 2 &&
        user?.type === "staff" &&
        value.roles === 25)
    ) {
      // console.log("masuk 1");

      params.operational = user.operational;
    } else {
      // console.log("masuk 2");

      if (objectUser?.property && value.operational) {
        // console.log("masuk 3");
        const propertyIndex = objectUser.property.findIndex(
          (propertyObj) => propertyObj.id === value.operational
        );
        params.operational =
          propertyIndex > -1
            ? {
                id: objectUser.property[propertyIndex].id,
                name: objectUser.property[propertyIndex].name,
                level: objectUser.property[propertyIndex].level,
              }
            : {
                id: value.operational,
              };
      } else {
        // console.log("masuk 4");

        if (!value.operational && user?.operational?.level === 3) {
          // console.log("masuk 5");

          params.operational = user.operational;
        } else {
          // console.log("masuk 6");

          params.operational = {
            id: value.operational,
          };
        }
      }
    }
    // Tenant
    if (user?.type === "tenant") {
      params.tenant = user.tenant;
    } else {
      if (objectUser?.tenant) {
        const tenantIndex = objectUser.tenant.findIndex(
          (tenantObj) => tenantObj.id === value.tenant
        );
        params.tenant =
          tenantIndex > -1
            ? objectUser.tenant[tenantIndex]
            : {
                id: value.tenant,
              };
      } else {
        params.tenant = {
          id: value.tenant,
        };
      }
    }
    // console.log(params);
    return instance.post(`/user`, params);
  };

  static patchData = async (value) => {
    const instance = await ApiService();
    const params = {
      password: md5(value.password),
    };
    return instance.patch(`/user/${value.id}`, params);
  };

  static putData = async (value, objectUser) => {
    const instance = await ApiService();
    const params = {
      id: value.id,
      verified_email: true,
      default_password: false,
      image_url: "https://image.com",
      name: value.name,
      username: value.email,
      birthdate: value.birthdate,
      gender: value.gender,
      email: value.email,
      phone: value.phone,
      address: value.address,
      nationality: "ind",
      language: "en",
      token: "this is a token",
      fcm_token: "aiueo",
      fcm_token_web: "test",
      off_duty: false,
      type: value.type,
    };
    // Role
    if (objectUser?.roles) {
      const roleIndex = objectUser.roles.findIndex(
        (role) => role.id === value.roles
      );
      params.role =
        roleIndex > -1 ? objectUser.roles[roleIndex] : { id: value.roles };
    } else {
      params.role = {
        id: value.roles,
      };
    }
    // Property
    if (
      (user?.operational?.level === 1 && user?.type === "staff") ||
      (user?.operational?.level === 2 &&
        user?.type === "staff" &&
        value.roles === 2)
    ) {
      params.operational = user.operational;
    } else {
      if (objectUser?.property && value.operational) {
        const propertyIndex = objectUser.property.findIndex(
          (propertyObj) => propertyObj.id === value.operational
        );
        params.operational =
          propertyIndex > -1
            ? {
                id: objectUser.property[propertyIndex].id,
                name: objectUser.property[propertyIndex].name,
                level: objectUser.property[propertyIndex].level,
              }
            : {
                id: value.operational,
              };
      } else {
        if (!value.operational && user?.operational?.level === 3) {
          params.operational = user.operational;
        } else {
          params.operational = {
            id: value.operational,
          };
        }
      }
    }
    // Tenant
    if (user?.type === "tenant") {
      params.tenant = user.tenant;
    } else {
      if (objectUser?.tenant) {
        const tenantIndex = objectUser.tenant.findIndex(
          (tenantObj) => tenantObj.id === value.tenant
        );
        params.tenant =
          tenantIndex > -1
            ? objectUser.tenant[tenantIndex]
            : {
                id: value.tenant,
              };
      } else {
        params.tenant = {
          id: value.tenant,
        };
      }
    }

    return instance.put(`/user/${value.id}`, params);
  };

  static patch = async (id, params) => {
    const instance = await ApiService();
    return instance.patch(`/user/${id}`, params);
  };

  static deleteData = async (params) => {
    const instance = await ApiService();
    return instance.delete(`/user/${params.id}`);
  };
}
